export interface SnackbarState {
    show: boolean;
}

export const initialSnackbarState: SnackbarState = {
    show: false
};
